import React from 'react';

interface SuccessMessageProps {
  success: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ success }) => {
  return (
    <div className=' font-semibold'>
      <p className='text-[#838300] bg-[#F9F9AE] py-4 pl-7 '>{success}</p>
    </div>
  );
};

export default SuccessMessage;
